import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../apis/store";
import {
  getDateRange,
  scroll,
} from "../../../../components/utils/utils";
import { Col, Row } from "antd";
import Selects from "../../../../biblio/Selects/Selects";
import DotsLoader from "../../../../biblio/Loader/DotsLoader";
import RegistrationUniversityCollapse from "./ResgitrationUniversityAppliationsCollapse";
import PaginationComponent from "../../../../biblio/Pagination/PaginationComponent";
import { getBeneficiaryDetails } from "../../../../apis/actions/recipient.actions";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import AddRegistrationRequest from "./AddRegistrationRequest";
import {
  getUniversities,
  getAlluniversityApplications,
} from "../../../../apis/actions/scholarship.actions";
import CustomConfigProvider from "../../ProfileHeader";
const RegistrationApplicationsUniversityRequest = () => {
  const dispatch = useDispatch<AppDispatch>();
  const currentRef = useRef<HTMLDivElement>(null);

  const { universities, TotalUniversityApplications } = useSelector(
    (state: RootState) => state?.scholarship
  );
  const { data: universityApplications, loading } = useSelector(
    (state: RootState) => state?.scholarship?.universityApplications
  );
  const { beneficiaryDetails } = useSelector(
    (state: RootState) => state?.recipient
  );

  useEffect(() => {
    dispatch(getBeneficiaryDetails());
    dispatch(getUniversities());
  }, [dispatch]);

  const [selectedFilter, setSelectedFilter] = useState<any>(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [state, setState] = useState({
    year: "",
    month: "",
  });

  const filterOrphans =
    beneficiaryDetails?.person_ids &&
    beneficiaryDetails.person_ids.filter(
      (person: any) =>
        person?.beneficiary_type === "son" ||
        person?.beneficiary_type === "daughter"
    );
  useEffect(() => {
    setCurrentPage(1);
  }, [state, selectedFilter]);
  useEffect(() => {
    const { date_from, date_to } = getDateRange(state.year, state.month);
    dispatch(
      getAlluniversityApplications({
        limit: itemPerPage,
        page: currentPage,
        partner_id: selectedFilter,
        date_from: date_from,
        date_to: date_to,
      })
    );
  }, [dispatch, selectedFilter, currentPage, state]);
  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };
  const itemPerPage = 8;

  const handleSelectChange = (value: any) => {
    if (value) {
      setSelectedFilter(
        // eslint-disable-next-line eqeqeq
        filterOrphans.filter((person: any) => person.name == value.label)[0].id
      );
      setCurrentPage(1);
    } else {
      setSelectedFilter(null);
    }
  };

  return (
    <>
      <CustomConfigProvider
        title="التسجيل في الجامعات"
        withdateFilter={true}
        filterState={state}
        setState={(values) => setState(values)}
      >
        <Selects
          options={filterOrphans}
          selectPlaceholder="المستفيد"
          onChange={handleSelectChange}
          allowClear={true}
          className="takaful--service-select takaful--request-select"
          popupClassName="takaful--service-select-dropdown"
        />
      </CustomConfigProvider>

      <Row
        justify={"space-between"}
        className="takaful--request-col-space"
        style={{ marginBottom: "2rem" }}
      >
        <Col xxl={4} xl={4} lg={4} md={4} sm={24} xs={24}>
          <PrimaryButton
            onClick={() => setIsModalVisible(true)}
            title="طلب تسجيل في الجامعة"
            className="takaful--add-request-btn"
          />
        </Col>
        <Col xxl={20} xl={20} lg={20} md={20} sm={24} xs={24}></Col>
      </Row>
      {loading ? (
        <div
          className="takaful--loading-projects-cases"
          style={{ marginTop: "5rem" }}
        >
          <p className="takaful--no-project-message"> جارٍ التحميل</p>
          <DotsLoader />
        </div>
      ) : universityApplications?.length === 0 &&
        (!selectedFilter &&
        // eslint-disable-next-line eqeqeq
        state.year == "") ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا يوجد طلبات
        </p>
      ) : universityApplications?.length === 0 &&
        (selectedFilter || state.year !== "") ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا يوجد طلبات تتوافق مع البحث الذي قمت به
        </p>
      ) : (
        <>
          <Row gutter={[16, 48]} justify={"space-around"} ref={currentRef}>
            <RegistrationUniversityCollapse requests={universityApplications} />
          </Row>
          <div className="takaful--pagination-container">
            {universityApplications &&
              Math.ceil(TotalUniversityApplications) * itemPerPage >
                itemPerPage && (
                <PaginationComponent
                  active={currentPage}
                  total={Math.ceil(TotalUniversityApplications) * itemPerPage}
                  itemPerPage={itemPerPage}
                  scroll={() => scroll(currentRef)}
                  setActive={(nb) => updateActive(nb)}
                />
              )}
          </div>
        </>
      )}

      <AddRegistrationRequest
        beneficiary={filterOrphans}
        universities={universities}
        setIsModalVisible={setIsModalVisible}
        isModalVisible={isModalVisible}
      />
    </>
  );
};

export default RegistrationApplicationsUniversityRequest;
